module.exports = __webpack_public_path__ + "img/Coloca_Pega Porcelánicos Gris.5ae65ae2.png";